module.exports = __webpack_public_path__ + "static/media/bicycles.05f60c95.jpg";